import { render, staticRenderFns } from "./PaidInfoInput.vue?vue&type=template&id=6144c2b4&scoped=true&"
import script from "./PaidInfoInput.vue?vue&type=script&lang=js&"
export * from "./PaidInfoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144c2b4",
  null
  
)

export default component.exports